/** This can not be done using a composable as defineProps has a different scope than the rest of the setup script. */

import uuid from '../../../helpers/uuid';

export const defaultProps = {
    label: {
        type: String,
        default: null,
    },

    name: {
        type: String,
        default: uuid(20),
    },

    required: {
        type: [Boolean, String],
        default: false,
    },

    message: {
        type: String,
        default: null,
    },

    errorMessage: {
        type: String,
        default: null,
    },
};

export const defaultFieldProps = {
    ...defaultProps,

    placeholder: {
        type: String,
        required: false,
        default: null,
    },

    autocomplete: {
        type: String,
        required: false,
        default: null,
        validator: (value) => {
            const validValues = [
                'on', 'off',
                'name', 'honorific-prefix', 'given-name', 'additional-name', 'family-name', 'honorific-suffix',
                'nickname', 'email', 'username', 'new-password', 'current-password',
                'organization-title', 'organization', 'street-address', 'address-line1', 'address-line2', 'address-line3',
                'address-level1', 'address-level2', 'address-level3', 'address-level4', 'country', 'country-name',
                'postal-code', 'cc-name', 'cc-given-name', 'cc-additional-name', 'cc-family-name',
                'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc', 'cc-type',
                'transaction-currency', 'transaction-amount', 'language', 'bday', 'bday-day', 'bday-month', 'bday-year',
                'sex', 'tel', 'tel-country-code', 'tel-national', 'tel-area-code', 'tel-local', 'tel-local-prefix', 'tel-local-suffix',
                'tel-extension', 'url', 'photo'
            ];

            return value === null || validValues.includes(value);
        },
    },
};
